// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"PageNotFound_page-not-found__1f8_l","btn":"PageNotFound_btn__2JrHS"};